import Cookies from 'universal-cookie'

const cookies = new Cookies()

export const getCookie = name => cookies.get(name)
export const setCookie = (name, value, options) => cookies.set(name, value, options)